import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const inventoryUnitsAdapter = getAdapter();

const inventoryUnitsSlice = createSlice({
  name: 'inventoryUnits',
  initialState: inventoryUnitsAdapter.getInitialState(),
  reducers: {
    setInventoryUnits: (state, { payload: { inventoryUnits } }) => {
      inventoryUnitsAdapter.setMany(state, inventoryUnits);
    },
  },
});

const selectors = inventoryUnitsAdapter.getSelectors(({ inventoryUnits }) => inventoryUnits);

export const getInventoryUnitsIncludingDeleted = (state) => selectors.selectAll(state);

export const getInventoryUnits = (state) => getInventoryUnitsIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setInventoryUnits,
} = inventoryUnitsSlice.actions;

export default inventoryUnitsSlice.reducer;
